/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_GeminiInputs */



/**
* | output |
* | --- |
* | "Gemini" |
*
* @param {Voice_Manager_Provider_GeminiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_gemini = /** @type {((inputs?: Voice_Manager_Provider_GeminiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_GeminiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Gemini")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gemini")
	return /** @type {LocalizedString} */ ("Gemini")
});